(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mutis-bundle-benefits"] && !Shopify.designMode) return;
  try {
    function initMutisBundleBenefits() {
    document.querySelectorAll('[data-mutis-bundle-benefits]').forEach((benefits) => {
      if (benefits.dataset.initialized === 'true') return;

      benefits.dataset.initialized = 'true';
      const root = benefits.closest('[id^="MainProduct-"]') || document;
      const bundleName = benefits.dataset.bundleName;
      const bundleIndex = benefits.dataset.bundleIndex;

      const syncBenefits = () => {
        const submitButton = root.querySelector('.product-form__submit');
        if (submitButton && benefits.nextElementSibling !== submitButton) {
          submitButton.before(benefits);
        }

        const selected = Array.from(root.querySelectorAll('input[type="radio"]')).find(
          (input) => input.name === bundleName && input.checked
        );
        const bundleTwoSelected = Boolean(
          selected && selected.id.includes(`rapi-bundles-deal-${bundleIndex}-`)
        );
        benefits.hidden = !selected;
        benefits.querySelectorAll('[data-mutis-exclusive-benefit]').forEach((card) => {
          card.classList.toggle('is-locked', !bundleTwoSelected);
        });
      };

      root.addEventListener('change', (event) => {
        if (event.target instanceof HTMLInputElement && event.target.name === bundleName) {
          syncBenefits();
        }
      });

      root.addEventListener('click', (event) => {
        const label = event.target.closest('label[for^="rapi-bundles-deal-"]');
        if (label) requestAnimationFrame(syncBenefits);
      });

      const observer = new MutationObserver(syncBenefits);
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['checked', 'class', 'style']
      });
      syncBenefits();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMutisBundleBenefits);
  } else {
    initMutisBundleBenefits();
  }

  document.addEventListener('shopify:section:load', initMutisBundleBenefits);
  } catch(e) { console.error(e); }
})();

})();
